import React from 'react'
import { Box, TextBody } from '@ally/metronome-ui'
import WarningIcon from './WarningIcon'

interface NoticeProps {
  dataTestId?: string
}

const StaleDataNotice: React.FC<NoticeProps> = ({
  dataTestId = 'stale-data-notice',
}) => {
  return (
    <Box mb="sm" lineHeight={1.5} display="flex" data-testid={dataTestId}>
      <Box display="inline">
        <WarningIcon />
      </Box>
      <TextBody tag="p" size="sm">
        We’ve hit a snag when trying to update your account information. A fix
        is in the works.
      </TextBody>
    </Box>
  )
}

export default StaleDataNotice
